<template>
  <video-player-trailer
    @close="playbackTrailer = false"
    :trailer="trailer"
    v-if="playbackTrailer"
  />
  <template v-else>
    <div
      id="nl"
      v-bind:class="{ opaloading: loading, mobile: isMobile() }"
      class="movie-page"
      v-if="render"
    >

      <movie-header
        :asset="asset"
        @playTrailer="playTrailer"
      />


      <div class="container-fluid movie-detail-content">
        <div v-if="expired" class="row">
          <div
            class="col d-flex justify-content-center justify-content-md-start"
          >
            <span class="expired-label">
              {{ $t("detail_page.no_longer_available") }}
            </span>
          </div>
        </div>
        
        <template v-if="showMobileLayout">
          <div class="row metadata-description mt-5 pt-5">
            <div class="col-12 col-md-6">
              <h2>{{ $t("detail_page.about") }}</h2>
              <p>{{ asset.description }}</p>
            </div>
            <div class="col-12 col-md-6 text-gray-3">
              <p>
                <strong>{{ $t("detail_page.country") }}</strong>
                <span>{{ asset.country }}</span>
              </p>
              <p>
                <strong>{{ $t("detail_page.directors") }}</strong>
                <span>{{ director(asset.directors) }}</span>
              </p>
              <p>
                <strong>{{ $t("detail_page.cast") }}</strong>
                <span>{{ casting(asset.actors) }}</span>
              </p>
            </div>
          </div>
          <hr class="divider mb-1" />
        </template>

        <tabbed-horizontal-carousel
          v-if="type === 'movie'"
          :type="type"
          :title="asset.title"
          :assets="asset.extras"
          v-bind:key="asset.slug"
        />
        <tabbed-episodes
          v-else-if="type === 'series' && asset.seasons.length > 0"
          :type="type"
          :title="asset.title"
          :seasons="asset.seasons"
          :assets="asset.extras"
          :slug="asset.slug"
          v-bind:key="asset.slug"
        />

        <hr class="divider mt-1" />
        <f-a-q-components :faq="faq"></f-a-q-components>
        <be-part-of></be-part-of>
      </div>
    </div>
    <div v-else-if="!isMobile()" class="skeleton container">
      <img src="@/assets/img/details/skeleton.svg" />
    </div>
  </template>
</template>
<script>
import FAQComponents from "@/components/generic/FAQComponents.vue";
import BePartOf from "@/components/landing/BePartOf.vue";
import TabbedHorizontalCarousel from "@/components/movies/TabbedHorizontalCarousel.vue";
import TabbedEpisodes from "@/components/movies/TabbedEpisodes.vue";
import { OrizonApiClient } from "@/services/OrizonApiClient";
import VideoPlayerTrailer from "@/components/public/VideoPlayerTrailer.vue";
import Cookie from "@/services/Cookie";
import MovieHeader from "../../components/loggedOutMovies/MovieHeader.vue";
import { UIStore } from "@/stores/uiStore";
import { mapState } from "pinia";
import axios from "axios";
const apiClient = new OrizonApiClient();
export default {
  name: "MoviePage",
  components: {
    MovieHeader,
    VideoPlayerTrailer,
    TabbedEpisodes,
    TabbedHorizontalCarousel,
    BePartOf,
    FAQComponents,
  },
  props: {
    slug: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
  },
  methods: {
    playTrailer() {
      this.trailer.url = this.asset.trailer;
      this.trailer.title = this.asset.title;
      this.trailer.poster = this.asset.screenshot.original;
      setTimeout(() => {
        this.playbackTrailer = true;
      }, 1000);
    },
    background(asset) {
      let trailing = this.supportsWebP ? ".webp" : "";
      let bg = this.isMobile()
        ? asset.mobile + trailing
        : asset.desktop + trailing;
      return {
        background: "url('" + bg + "') no-repeat top center",
        backgroundSize: "contain",
      };
    },
    director(directors) {
      return directors.map((d) => d.name).join(", ");
    },
    casting(actors) {
      return actors.map((d) => d.name).join(", ");
    },
    fetchAsset(slug) {
      slug = slug.replaceAll("_", "-");
      if (this.loading) {
        return;
      }
      this.loading = true;
      apiClient.get("/asset/" + slug).then((response) => {
        this.loading = false;
        if (response.error === null) {
          if (this.type === "movie") {
            this.movie = response.data;
          } else {
            this.serie = response.data;
          }
          if (this.type !== response.data.type) {
            this.$router.push(response.data.url);
          }
        } else {
          this.$router.push({ name: "404" });
        }
      });
    },
  },
  updated() {
    this.$meta.update(this.asset, this.$t);
    axios
        .get(`https://flixlatino-feeds.s3.us-east-1.amazonaws.com/google_feed/resource/${this.asset.slug}-${this.$i18n.locale}-feed.json`)
        .then(({ data }) => {
          this.$meta.updateVideoJsonLd(data);
        });
  },
  computed: {
    ...mapState(UIStore, ["showMobileLayout"]),
    expired() {
      return (
        new Date(this["asset"]["expiration_date"]) < new Date() ||
        this["asset"]["expired"] === true
      );
    },
    faq() {
      let faq = [];
      if (this.$i18n.locale === "en") {
        faq = [
          {
            title: `Where can I watch "${this.asset.title}"?`,
            text: `You can watch "${this.asset.title}" on FlixLatino. <a href="/en/register">Subscribe</a> and watch it today.`,
          },
          {
            title: `How can I watch "${this.asset.title}"?`,
            text: `Download the FlixLatino app or <a href="/en/login">sign in</a> to the website to watch ${this.asset.title} today!`,
          },
        ];
      } else {
        faq = [
          {
            title: `¿Dónde puedo ver "${this.asset.title}"?`,
            text: `Puedes ver "${this.asset.title}" por FlixLatino. <a href="/es/registro">Regístrate</a> hoy para verla.`,
          },
          {
            title: `¿Cómo puedo ver "${this.asset.title}"?`,
            text: `¡Descarga el app de FlixLatino o <a href="/es/iniciar-sesion">inicia sesión</a> en la pagina web  para mirar ${this.asset.title} hoy!`,
          },
        ];
      }

      return faq;
    },
    asset() {
      return this.type === "movie" ? this.movie : this.serie;
    },
    render() {
      return Object.keys(this.asset).length > 0;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (typeof to.params.slug !== "undefined") {
        vm.fetchAsset(to.params.slug);
      }
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (typeof to.params.slug !== "undefined") {
      this.fetchAsset(to.params.slug);
    }
    next();
  },
  beforeRouteLeave(to) {
    if (["login", "register", "logout"].indexOf(to.name) === -1) {
      Cookie.erase("flx_visited_title_page");
    }
  },
  mounted() {
    if (typeof this.slug !== "undefined") {
      this.fetchAsset(this.slug);
      this.$bus.on("langChanged", () => {
        this.fetchAsset(this.slug);
      });
    }
  },
  data() {
    return {
      trailer: {
        title: null,
        url: null,
        poster: null,
      },
      playbackTrailer: false,
      loading: false,
      movie: {},
      serie: {},
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/colors";
.expired-label {
  background: rgb(213, 31, 39);
  background: linear-gradient(
    145deg,
    rgba(109, 93, 207, 1) 0%,
    rgba(213, 31, 39, 1) 100%
  );
  min-width: 300px;
  min-height: 35px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 18px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
}
@media (max-width: 1024px) {
  .container-lg,
  .container-md,
  .container-sm,
  .container {
    max-width: 100% !important;
  }
}
/* Define la animación */

.movie-page {
  &.mobile {
    // margin-top: 63px;
    .buttons {
      display: flex;
      flex-direction: column;
      & > * {
        width: 100%;
        display: block;
      }
    }
  }

  a:hover,
  button:hover {
    color: #ffffff;
    text-shadow: #ffffff 0 0 10px;
    transition: text-shadow 0.3s ease-in-out;
  }
  .back-position {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    padding: 1em;
  }

  &.opaloading {
    opacity: 0.1;
    transition: opacity 2s ease-in-out;
  }
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
  // padding-top: 330px;
  position: relative;
  .metadata-description {
    margin-top: 2em;
    h3 {
      font-size: 1.2em;
      font-weight: 600;
      margin-bottom: 1em;
    }
    p {
      font-size: 1em;
      font-weight: 300;
      line-height: 1.5em;
      opacity: 0.8;
    }
  }
  &:before {
    content: "";
    background: linear-gradient(
      180deg,
      rgba(13, 20, 32, 0) 0%,
      rgba(13, 20, 33, 0.65) 56.08%,
      #0d1421 100%
    );
    display: block;
    width: 100%;
    position: absolute;
    height: 380px;
    top: 200px;
    left: 0;
  }
  .metadata {
    opacity: 0.8;
    color: #ffffff;
    font-size: 1em;
    font-weight: 300;
    .genres {
      padding: 0 0.3em;
    }
  }
  h1 {
    color: #ffffff;
  }
  .movie-title {
    margin: 0.5em 0 1em;
  }
  .title-logo {
    height: 100px;
  }
  @media only screen and (width: 430px) and (-webkit-device-pixel-ratio: 3) {
    padding-top: 300px;
  }
}

@media (min-width: 1440px) {
  .movie-detail-content{
    margin-top: -6em;
  }
}
</style>
